// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1Pu81","alert":"SettungsInbox_alert__Yuc6P"};